import React from "react";
import {VisuallyHidden} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import {IntlNamespaces} from "../../../../translations/types";
import {
    INTL_AMBASSADOR_DEGREE_TITLE,
    INTL_AMBASSADOR_NAME,
    INTL_AMBASSADOR_TYPE,
    INTL_CHAT_CREATION_SOURCE,
    INTL_LAST_MESSAGE,
    INTL_LAST_MESSAGE_SENT_DATE_TIME,
    INTL_UNREAD_MESSAGES,
} from "../../../../translations/inbox";

type InboxItemAriaTextProps = {
    id: string;
    name: string;
    role: string;
    degreeTitle: string;
    creationSource: string;
    unreadMessageCount: number;
    lastMessage: string;
    date: string;
    time: string;
};

export const InboxItemAriaText = ({
    id,
    name,
    role,
    degreeTitle,
    creationSource,
    unreadMessageCount,
    lastMessage,
    date,
    time,
}: InboxItemAriaTextProps) => {
    const {t} = useTranslation(IntlNamespaces.INBOX);
    return (
        <VisuallyHidden>
            <span id={`inbox-item-desc-${id}`}>
                {`
                    ${t(INTL_AMBASSADOR_NAME.key, INTL_AMBASSADOR_NAME.intlValue, {
                        name,
                    })}.
                   ${t(INTL_AMBASSADOR_TYPE.key, INTL_AMBASSADOR_TYPE.intlValue, {
                       role,
                   })}.
                    ${t(INTL_AMBASSADOR_DEGREE_TITLE.key, INTL_AMBASSADOR_DEGREE_TITLE.intlValue, {
                        role,
                        degreeTitle,
                    })}.
                    ${t(INTL_CHAT_CREATION_SOURCE.key, INTL_CHAT_CREATION_SOURCE.intlValue, {
                        creationSource,
                    })}.
                    ${t(INTL_UNREAD_MESSAGES.key, INTL_UNREAD_MESSAGES.intlValue, {
                        unreadMessageCount,
                    })}.
                    ${t(INTL_LAST_MESSAGE.key, INTL_LAST_MESSAGE.intlValue, {
                        lastMessage,
                    })}.
                    ${t(
                        INTL_LAST_MESSAGE_SENT_DATE_TIME.key,
                        INTL_LAST_MESSAGE_SENT_DATE_TIME.intlValue,
                        {
                            date,
                            time,
                        },
                    )}.
                    `}
            </span>
        </VisuallyHidden>
    );
};
